import { IProfile } from "@/types/IProfile";
import { AxiosRequestConfig } from "axios";
import getAxiosObj from "./request";
const getQueryStringParams = (query: string) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params: { [key: string]: string }, param) => {
          // Add index signature to params
          let [key, value] = param.split("=");
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : "";
          return params;
        }, {})
    : {};
};

const urlfilter = (pathname: string, str: string) => {
  return pathname.indexOf(str) > -1 ? true : false;
};

const isExistsInUrl = (str: string) => {
  return window.location.pathname.includes(str);
};

const getTrimmedStr = (str: string, length: number) => {
  return str.length > length ? str.substring(0, length) + "..." : str;
};

const retry = 3;
const retryDelay = 1000;

const retryCall = async (config: AxiosRequestConfig) => {
  let response;
  const axiosObj = getAxiosObj();
  for (let i = 0; i < retry; i++) {
    try {
      response = await axiosObj<IProfile>(config);
      return response.data;
    } catch (error: any) {
      if (error.response.status === 500) {
        continue;
      } else {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
};

const isAllowedExt = (fileExtension: string) => {
  const allowedExtensions = [
    ".png",
    ".jpeg",
    ".jpg",
    ".webp",
    ".gif",
    ".tiff",
    ".mov",
    ".mp4",
    ".m4v",
  ];
  return allowedExtensions.includes(`.${fileExtension?.toLowerCase()}`);
};

const isAllowedExtForImage = (fileExtension: string) => {
  const allowedExtensions = [
    ".png",
    ".jpeg",
    ".jpg",
    ".webp",
    ".gif",
    ".tiff",
  ];
  return allowedExtensions.includes(`.${fileExtension?.toLowerCase()}`);
};

const isWordStrtWithAt = (newText: string) => {
  // get last typed word which starts with @
  const regex = /@\S+$/; // match all words starting with @
  const match = newText.match(regex);
  return match && match[0] && match[0][0] === "@";
};

const getDeepCopy = (obj: any): any => {
  return JSON.parse(JSON.stringify(obj));
};

const getClrByTag = (tag: string) => {
  switch (tag) {
    case "trading":
      return "bg-outred-base text-outext-opposite";
    case "investing":
      return "outgreen";
    case "alpha hunting":
      return "outeal";
    case "memes":
      return "outyellow";
    case "nft":
      return "outpurple";
    case "games":
      return "outpink";
    case "defi":
      return "outblue";
    case "gambling":
      return "outorange";
    case "personal":
      return "outgreen";
    case "news":
      return "outblue";
    default:
      return "outeal";
  }
};
const getNormalClr = (tag: string) => {
  switch (tag.toLocaleLowerCase()) {
    case "trading":
      return "bg-outred-light text-outred-darker";
    case "investing":
      return "bg-outgreen-light text-outgreen-darker";
    case "alpha hunting":
      return "bg-outeal-light text-outeal-darker";
    case "memes":
      return "bg-outyellow-light text-outyellow-darker";
    case "nft":
      return "bg-outpurple-light text-outpurple-darker";
    case "games":
      return "bg-outpink-light text-outpink-darker";
    case "defi":
      return "bg-outblue-light text-outblue-darker";
    case "gambling":
      return "bg-outorange-light text-outorange-darker";
    case "personal":
      return "bg-outgreen-light text-outgreen-darker";
    case "news":
      return "bg-outblue-light text-outblue-darker";
    default:
      return "bg-outeal-light text-outeal-darker";
  }
};
const trimIt = (str: string = "", noOfChars: number) => {
  if (!str) return "";
  return str.length > noOfChars ? str.substring(0, noOfChars - 3) + "..." : str;
};
/**
 *
 * Consts
 */

const acceptExts: string = ".png,.jpeg,.jpg,.webp,.gif,.tiff,.mov,.mp4,.m4v";
const lg = 1064;

const shortenAddress = (address : string , len = 4) => {
  // Check if the address is valid and has a minimum length
  if (!address || address.length < 10) {
    return address; // Return the address as is if it's too short to be shortened
  }

  const start = address.substring(0, len); // Get the first 8 characters
  const end = address.substring(address.length - len); // Get the last 8 characters

  return `${start}•••${end}`; // Concatenate them with "...." in between
}

export {
  // Functions
  getQueryStringParams,
  urlfilter,
  isExistsInUrl,
  getTrimmedStr,
  retryCall,
  isAllowedExt,
  isWordStrtWithAt,
  getDeepCopy,
  getClrByTag,
  trimIt,
  getNormalClr,
  // Consts
  acceptExts,
  lg,
  shortenAddress,
  isAllowedExtForImage
};
